export var PopoverPosition;

(function (PopoverPosition) {
  PopoverPosition["TopLeading"] = "top-leading";
  PopoverPosition["TopCenter"] = "top-center";
  PopoverPosition["TopTrailing"] = "top-trailing";
  PopoverPosition["BottomLeading"] = "bottom-leading";
  PopoverPosition["BottomCenter"] = "bottom-center";
  PopoverPosition["BottomTrailing"] = "bottom-trailing";
})(PopoverPosition || (PopoverPosition = {}));